import { z } from 'zod';

export const fileHashEntrySchema = z.object({
    hash: z
        .string()
        .length(64)
        .regex(/^[0-9a-f]+$/),
    timestamp: z.string().datetime(),
});

export type FileHashEntrySchema = z.infer<typeof fileHashEntrySchema>;

export const fileHashCacheSchema = z.object({
    version: z.literal(1),
    devices: z.record(z.string(), z.record(z.string(), fileHashEntrySchema)),
});

export type FileHashCacheSchema = z.infer<typeof fileHashCacheSchema>;
